<template lang='pug'>
transition(name="response-form")
  .canned-response-form-wrapper(
    v-show="responseFormShown"
    @keyup.esc="closeForm")
    div.canned-response-editor
      button.btn.muted.close-form(
        @click="closeForm"
        title="Close canned response form")
        svg.svgicon(xmlns='http://www.w3.org/2000/svg', viewBox="0 0 320 512")
          path(d="M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z")

      h1.heading(v-if="id === null") Create canned response
      h1.heading(v-else) Edit canned response

      form(v-on:submit.prevent="")
        //- Title
        div.form-group
          label Title
          input(
            type="text"
            placeholder="The title of your canned response - internal use only"
            v-model="title"
            ref="title")
          validation-message(:message="validationMessages.title")
        //- Author
        div.form-group
          label Author
          input(
            type="text"
            placeholder="The author of this canned response"
            v-model="author")
          validation-message(:message="validationMessages.author")
        //- Tags
        div.form-group
          label Tags
          div.tag-list
          input(
            type="text"
            placeholder="Input tags in comma separated list"
            v-model="tags")
          validation-message(:message="validationMessages.tags")
        //- Message
        div.form-group
          label Message
          textarea(v-model="message")
          validation-message(:message="validationMessages.message")
        //- Display set attachments
        div.form-group(v-if="attachments.length > 0")
          label Attachments - Click to remove
          ul.attachment-list
            li
              button.tag.primary(@click="removeAllAttachments()") Remove all attachment(s)
            template(v-for="(attachment, index) in attachments")
              li
                button.tag.primary(
                  @click="removeAttachment(index)"
                  :class="attachment.type.toLowerCase()")
                  | {{ attachment.type }}:&nbsp;
                  b {{ attachment.content }}
          validation-message(:message="validationMessages.attachments")

        //- Add attachment(s)
        div.form-group
          label Add an attachment
          .button-group
            button.tag(
              @click="toggleAttachment('ACTIVITY')"
              :class="{ active: messageAttachmentType === 'ACTIVITY' }")
              | Activity
            button.tag(
              @click="toggleAttachment('INTERNAL_LINK')"
              :class="{ active: messageAttachmentType === 'INTERNAL_LINK' }")
              | Internal
            button.tag(
              @click="toggleAttachment('EXTERNAL_LINK')"
              :class="{ active: messageAttachmentType === 'EXTERNAL_LINK' }")
              | External
            button.tag(
              @click="toggleAttachment('EXTERNAL_LINK_PHONE')"
              :class="{ active: messageAttachmentType === 'EXTERNAL_LINK_PHONE' }")
              | Phone number

            template(v-if="messageHasAttachment")
              div.input-group.attachment-message-group
                template(v-if="messageAttachmentType === 'INTERNAL_LINK'")
                  coaching-message-internal-link-input(
                    @internal-message-valid="addInternalLinkAttachment"
                    @internal-message-invalid="setCanAddAttachment(false)")
                template(v-else)
                  input.title(
                    v-if="messageAttachmentType === 'EXTERNAL_LINK'"
                    type="text"
                    placeholder="Input a external link title"
                    v-model="externalLinkTitle"
                    ref="attachmentTitleInput")
                  input(
                    type="text"
                    :placeholder="`Input ${messageAttachmentType.toLowerCase().replace(/_/gi, ' ')} attachment`"
                    v-model="messageAttachmentUrl")
                button.btn.small.add-attachment(
                  title="Add attachment"
                  @click="addAttachment"
                  :disabled="!canAddAttachment")
                  | Add attachment
              validation-message(:message="validationMessages.attachment")
        hr
        div.form-group.form-group-submit
          button.btn.muted(@click.prevent="clearForm") Clear response
          button.btn.submit(
            @click="saveCannedResponse"
            type="submit")
            | Save response
        div.form-group
          validation-message(
            :message="validationMessages.formSuccess"
            source-type="success")
</template>
<script>
import ValidationMessage from '@/components/coaching/cannedResponses/ValidationMessage.vue';
import CoachingMessageInternalLinkInput from '@/components/coaching/CoachingMessageInternalLinkInput.vue';
import alertSvc from '@/services/alertSvc.js';
import validURL from 'valid-url';

import { mapActions } from 'vuex';

const defaultCannedMessageType = 'CoachCannedMessage';

export default {
  name: 'CannedResponseForm',
  props: ['selected-response', 'selected-on'],
  components: {
    ValidationMessage,
    CoachingMessageInternalLinkInput
  },
  data() {
    return {
      responseFormShown: false,
      originalIndex: null,
      isExistingResponse: false,
      canAddAttachment: true,
      id: null,
      type: null,
      title: '',
      author: '',
      tags: '',
      message: '',
      attachments: [],
      messageAttachmentUrl: '',
      messageHasAttachment: false,
      messageAttachmentType: null,
      defaultCannedMessageType: defaultCannedMessageType,
      externalLinkTitle: '',
      validationMessages: {
        title: '',
        author: '',
        tags: '',
        message: '',
        attachments: '',
        attachment: '',
        formSuccess: ''
      }
    };
  },
  methods: {
    clearForm() {
      // Reset all the things
      this.originalIndex = null;
      this.id = null;
      this.type = this.defaultCannedMessageType;
      this.title = '';
      this.author = '';
      this.tags = '';
      this.message = '';
      this.attachments = [];
      this.isExistingResponse = false;

      // Empty validation messages
      for (const key in this.validationMessages) {
        this.validationMessages[key] = '';
      }

      // Reset attachment input
      this.resetAttachmentState();
    },
    closeForm() {
      this.responseFormShown = false;
    },
    setSelectedResponse() {
      // Reset form before updating data;
      this.clearForm();

      // Detect new or cleared response
      // - Early return and instead use blank models
      if (
        !this.selectedResponse ||
        Object.keys(this.selectedResponse).length === 0
      ) {
        return;
      }

      // Make copy to prevent mutation
      const selectedResponse = Object.assign({}, this.selectedResponse);
      this.id = selectedResponse.id;
      this.tags = selectedResponse.tags;
      this.type = selectedResponse.type;
      this.title = selectedResponse.title;
      this.author = selectedResponse.author;
      this.message = selectedResponse.message;
      this.attachments = selectedResponse.attachments.slice(0);

      this.isExistingResponse = true;
    },
    resetAttachmentState() {
      this.externalLinkTitle = '';
      this.messageAttachmentUrl = '';
      this.messageHasAttachment = false;
      this.messageAttachmentType = null;
      this.validationMessages.attachment = '';
    },
    addAttachment() {
      // Validate attachment
      const validAttachments = this.validateAttachment();
      const payloadAttachmentType =
        this.messageAttachmentType === 'EXTERNAL_LINK_PHONE'
          ? 'EXTERNAL_LINK'
          : this.messageAttachmentType;

      if (!validAttachments) {
        return;
      }

      let attachmentPayload = {
        type: payloadAttachmentType,
        content: this.messageAttachmentUrl
      };

      if (this.messageAttachmentType === 'EXTERNAL_LINK') {
        // Add title for EXTERNAL_LINK
        attachmentPayload.title = this.externalLinkTitle;
      } else if (this.messageAttachmentType === 'EXTERNAL_LINK_PHONE') {
        // Add title and tel: for EXTERNAL_LINK_PHONE
        attachmentPayload.title = this.messageAttachmentUrl;
        attachmentPayload.content = `tel:${attachmentPayload.content}`;
      }

      this.attachments.push(attachmentPayload);

      // Reset attachment input
      this.resetAttachmentState();
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
    },
    removeAllAttachments() {
      this.attachments = [];
    },
    setCanAddAttachment(value) {
      this.canAddAttachment = value;
    },
    addInternalLinkAttachment(internalLink) {
      this.messageAttachmentUrl = internalLink;
      this.setCanAddAttachment(true);
    },
    toggleAttachment(type) {
      // Toggle off btn & reset inputs if user clicks same button twice
      if (this.messageHasAttachment && this.messageAttachmentType === type) {
        this.resetAttachmentState();
        return;
      }

      this.messageHasAttachment = true;
      this.messageAttachmentType = type;
    },
    validateTitle() {
      if (this.isEmpty(this.title)) {
        this.validationMessages.title = 'Please input a title';
      } else {
        this.validationMessages.title = '';
        return true;
      }
      return false;
    },
    validateAuthor() {
      if (this.isEmpty(this.author)) {
        this.validationMessages.author = 'Please input an author';
      } else {
        this.validationMessages.author = '';
        return true;
      }
      return false;
    },
    validateMessage() {
      if (this.isEmpty(this.message)) {
        this.validationMessages.message = 'Please input the message body';
      } else {
        this.validationMessages.message = '';
        return true;
      }
      return false;
    },
    validateAttachment() {
      const attachmentMaxLength = 1024;
      let isValid = true;

      if (
        this.messageAttachmentType.length === 0 ||
        this.messageAttachmentUrl.trim().length === 0
      ) {
        this.validationMessages.attachment = 'Input attachment content';
        isValid = false;
      } else if (this.messageAttachmentUrl.length > attachmentMaxLength) {
        this.validationMessages.attachment = `Attachment URL length is longer than ${attachmentMaxLength} characters, consider using admin redirect or url shortener`;
        isValid = false;
      } else if (this.messageAttachmentType === 'EXTERNAL_LINK') {
        if (!this.isValidURL(this.messageAttachmentUrl)) {
          // Valid URL syntax
          this.validationMessages.attachment =
            'External link attachment URL is invalid. Test in a browser and retry.';
          isValid = false;
        } else if (this.externalLinkTitle.trim().length === 0) {
          this.validationMessages.attachment =
            'External links must have a title.';
          isValid = false;
        }
      } else if (this.messageAttachmentType === 'EXTERNAL_LINK_PHONE') {
        if (this.messageAttachmentUrl.length < 10) {
          this.validationMessages.attachment =
            'Phone number must be at least 10 numbers';
          isValid = false;
        } else if (!this.isNumeric(this.messageAttachmentUrl)) {
          this.validationMessages.attachment = 'Phone number must be numeric';
          isValid = false;
        }
      }

      if (isValid) {
        this.validationMessages.attachment = '';
      }

      return isValid;
    },
    // Aggregate form validator
    formIsValid() {
      const validTitle = this.validateTitle();
      const validAuthor = this.validateAuthor();
      const validMessage = this.validateMessage();

      if (validTitle && validAuthor && validMessage) {
        return true;
      }

      return false;
    },
    // Validation helper
    isEmpty(value) {
      return !value || value.trim().length === 0;
    },
    isValidURL(url) {
      return validURL.isWebUri(url);
    },
    isMyStrengthURL(url) {
      const myStrengthDomainRegex = new RegExp(
        '([a-zA-Z0-9-]*.)?mystrength.(com|me)',
        'g'
      );
      let parser = document.createElement('a');
      parser.href = url;

      return myStrengthDomainRegex.test(parser.hostname);
    },
    saveCannedResponse() {
      // Validate form
      if (!this.formIsValid()) {
        return;
      }

      // Insure that tags are an array
      if (this.tags && !Array.isArray(this.tags)) {
        this.tags = this.tags.split(',').reduce((newTags, tag) => {
          // Remove & invalid empty tags
          if (tag && tag.length > 0) {
            newTags.push(tag);
          }
          return newTags;
        }, []);
      }

      const newCannedResponse = {
        id: this.id,
        type: this.type,
        title: this.title,
        author: this.author,
        tags: this.tags,
        message: this.message,
        attachments: this.attachments
      };

      this.addNewCannedResponse(newCannedResponse);
    },
    addNewCannedResponse(newResponse) {
      // Tags to string
      newResponse.tags = newResponse.tags ? newResponse.tags.join(',') : '';

      this.saveCannedResponseMessages(newResponse)
        .then(response => {
          if (response.data.succeeded) {
            // Update list
            alertSvc.success('Coaching canned message updated.');

            this.$emit('new-canned-response-added');
            setTimeout(() => {
              this.closeForm();
            }, 300);
          } else {
            alertSvc.error(
              'Coaching canned message unable to be saved. Please reload the page and try again.'
            );
          }
        })
        .catch(error => {
          if (error.response.status === 422) {
            alertSvc.error(error.response.data.message);
          } else {
            alertSvc.error(error.message);
          }
        });
    },
    isNumeric(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    ...mapActions(['saveCannedResponseMessages'])
  },
  watch: {
    selectedOn() {
      this.responseFormShown = true;
      this.setSelectedResponse();

      // Scroll to top of form
      if (window.scroll) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo(0, 0);
      }

      // Actions as the animation completes
      setTimeout(() => {
        // Focus first input
        this.$refs.title.focus();
      }, 420);
    }
  },
  mounted() {
    this.setSelectedResponse();
  }
};
</script>
<style lang="scss" scoped>
.canned-response-form-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 32px;
  transform-style: preserve-3d;
  transform-origin: right top;
  transform: translateX(0);

  @keyframes showResponseForm {
    0% {
      opacity: 0;
      transform: translateY(-20%);
    }
    62% {
      opacity: 1;
    }
    100% {
      transform: translateY(0);
    }
  }

  $responseFormEasing: ease-out;

  // Vue transition styles
  &.response-form-enter-active {
    animation: showResponseForm 0.34s $responseFormEasing;
  }
  &.response-form-leave-active {
    animation: showResponseForm 0.34s reverse $responseFormEasing;
  }
}
.canned-response-editor {
  position: relative;

  .close-form {
    position: absolute;
    top: 0px;
    right: 0px;
    z-index: 10;
    padding: 11px 11px 10px;

    svg.svgicon {
      margin-right: 0;
      height: 24px;
      width: 24px;
    }
  }

  h1.heading {
    margin-top: 0;
  }

  .close-icon {
    transform: rotate(45deg);
    color: $error-color;
    position: relative;
    display: inline-block;
  }

  .input-group {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-end;

    input {
      display: inline-block;
      width: auto;
      flex-grow: 1;
      margin-right: 10px;
    }
    button {
      display: inline-block;
    }
  }

  .form-group {
    margin-bottom: 22px;

    &.form-group-submit {
      margin-top: 32px;
      text-align: right;
    }
  }

  .attachment-list {
    margin: 0;
    padding: 0;

    li {
      display: inline-block;
      margin-right: 4px;
      margin-bottom: 6px;
    }
    button.tag {
      position: relative;
      padding: 4px 8px;
      padding-left: 24px;
      border-radius: 1em;
      font-family: $sans-font-family;
      font-size: 1em;
      text-transform: uppercase;
      color: $grey;
      cursor: hand;
      background-image: linear-gradient(to bottom, #fff 70%, $md-grey-100);
      border: 1px solid $md-grey-200;
      transition: all 0.25s ease;
      &:before {
        content: '\2716';
        display: block;
        position: absolute;
        left: 6px;
        top: 6px;
        color: $error-color !important;
        font-size: $ms-down1;
      }
      &:hover,
      &:focus {
        border-color: $action-color;
        color: $action-color;
        background: #fff;
        @include drop-shadow;
        outline: none;
      }
      &:active {
        outline: none;
        opacity: 0.6;
        margin-top: 1px;
        box-shadow: 0 0 0 rgba(#fff, 0);
        transform: scale(0.98);
      }
      &.primary {
        color: $action-color;
        font-weight: $base-font-weight-strong;
      }
    }
  }

  // Activity
  .button-group {
    margin: $small-spacing auto;
  }
  button.tag {
    background-image: linear-gradient(to bottom, #fff 70%, $md-grey-100);
    position: relative;
    margin-right: 4px;
    padding: 4px 9px;
    padding-left: 26px;
    border-radius: 1em;
    font-family: $sans-font-family;
    font-size: 1em;
    text-transform: uppercase;
    color: $grey;
    cursor: hand;
    border: 1px solid $md-grey-200;
    transition: all 0.25s ease;

    &:before {
      content: '\2795';
      display: block;
      position: absolute;
      left: 6px;
      top: 7px;
      font-size: 0.8em;
    }
    &:active,
    &.active {
      outline: none;
      opacity: 0.6;
      box-shadow: 0 0 0 rgba(#fff, 0);
      transform: scale(0.98);
    }
    &:hover,
    &:focus {
      border-color: $action-color;
      color: $action-color;
      background: #fff;
      @include drop-shadow;
      outline: none;
    }

    &.active {
      border-color: $action-color;
    }
  }
  .attachment-message-group {
    margin-top: 14px;
  }
}
</style>
